// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   WixRegister.css
   Standalone, scoped stylesheet for WixRegister.js.
   All class names are prefixed with \`wxr-\` to avoid colliding
   with global / shared styles. Visual output is intended to
   match the previous combination of:
     - LandingPageRegister.css
     - components/widgetPreview.css
     - components/widgetCustomizationTab.css
   ========================================================= */

/* â”€â”€ CSS variables (scoped to the WixRegister root) â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-register-scope {
    --wxr-c-primary:        #5616ea;
    --wxr-c-primary-dark:   #4620c7;
    --wxr-c-grey-100:       #faf9ff;
    --wxr-c-grey-300:       #dbd9e4;
    --wxr-c-grey-600:       #555;
    --wxr-c-grey-800:       #333;
    --wxr-c-danger:         #dc3545;

    --wxr-r-s:              .5rem;
    --wxr-r-m:              .875rem;
    --wxr-shadow:           0 10px 24px rgba(0, 0, 0, .15);

    --wxr-sp-1:             .5rem;
    --wxr-sp-2:             .75rem;
    --wxr-sp-3:             1rem;
    --wxr-sp-4:             1.5rem;
    --wxr-sp-5:             2rem;
    --wxr-safe-top:         4rem;
    --wxr-safe-bottom:      35px;

    --wxr-swap-dur-out:     280ms;
    --wxr-swap-dur-in:      520ms;
    --wxr-swap-delay-in:    120ms;
}

@media (min-width: 768px) {
    .wxr-register-scope {
        --wxr-sp-3: 1.125rem;
        --wxr-sp-4: 2rem;
        --wxr-sp-5: 2.75rem;
    }
}

/* â”€â”€ Scoped reset â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-register-scope,
.wxr-register-scope *,
.wxr-register-scope *::before,
.wxr-register-scope *::after {
    box-sizing: border-box;
}

.wxr-register-scope {
    font-family: "DM Sans", sans-serif;
}

.wxr-register-scope img {
    display: block;
    max-width: 100%;
}

/* â”€â”€ Wrapper / page chrome â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-wrapper {
    height: 100vh;
    height: 100svh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--wxr-safe-top) var(--wxr-sp-4) var(--wxr-safe-bottom);
    background: linear-gradient(120deg, var(--wxr-c-primary) 0%, #320661 100%);
    position: relative;
}

.wxr-logo-register-site {
    position: fixed;
    z-index: 5;
    top: var(--wxr-sp-3);
    left: var(--wxr-sp-3);
    width: clamp(150px, 2vw, 50px);
}

.wxr-step-ind {
    position: absolute;
    top: var(--wxr-sp-3);
    right: var(--wxr-sp-4);
    color: #ffffff;
    font-weight: 500;
    font-size: 0.9rem;
}

/* â”€â”€ Steps slider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-steps-wrapper,
.wxr-steps-slider,
.wxr-step-slide {
    height: 100%;
}

.wxr-steps-wrapper {
    overflow: hidden;
    width: 100%;
}

.wxr-steps-slider {
    display: flex;
    width: 100%;
    transition: transform 0.5s ease;
}

.wxr-step-slide {
    flex: 0 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline: var(--wxr-sp-3);
}

/* â”€â”€ Cards / containers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-card-button-wrapper,
.wxr-chatbot-card,
.wxr-preview-parent-container,
.wxr-subscription-section {
    max-height: calc(100svh - var(--wxr-safe-top) - var(--wxr-safe-bottom) - 2 * var(--wxr-sp-4));
    overflow: auto;
    text-align: center;
}

.wxr-card,
.wxr-chatbot-card,
.wxr-preview-parent-container {
    background: #ffffff;
    border-radius: var(--wxr-r-m);
    box-shadow: var(--wxr-shadow);
}

.wxr-card {
    width: min(100%, 480px);
    padding: 25px;
    text-align: center;
}

.wxr-card.wxr-building {
    position: relative;
    background-color: #e1e5eb;
    opacity: 0.95;
    overflow: hidden;
}

.wxr-card.wxr-building::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
        transparent 0deg,
        transparent 160deg,
        rgba(94, 27, 255, 0.2) 190deg,
        rgba(94, 27, 255, 0.5) 210deg,
        #5616ea 230deg,
        #9966ff 295deg,
        #5d1cff 360deg
    );
    transform: translate(-50%, -50%);
    animation: wxr-rotateBorder 3s linear infinite;
    z-index: 0;
}

.wxr-card.wxr-building::after {
    content: '';
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    background: #ffffff;
    border-radius: calc(var(--wxr-r-m) - 6px);
    z-index: 0;
}

.wxr-card.wxr-building > * {
    position: relative;
    z-index: 1;
}

@keyframes wxr-rotateBorder {
    from { transform: translate(-50%, -50%) rotate(0deg); }
    to   { transform: translate(-50%, -50%) rotate(360deg); }
}

.wxr-chatbot-card {
    width: min(100%, 620px);
    padding: var(--wxr-sp-4) var(--wxr-sp-3);
    padding-top: 18px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
}

.wxr-preview-parent-container {
    width: 100%;
    max-width: 1000px;
    padding: var(--wxr-sp-4) var(--wxr-sp-3);
    padding-top: 18px;
    display: flex;
    flex-direction: column;
    gap: var(--wxr-sp-4);
}

.wxr-card-button-wrapper {
    width: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

/* â”€â”€ Primary button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-btn {
    width: 100%;
    max-width: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    padding: 0.85em 1.5em;
    font-weight: 600;
    font-size: 1.0625rem;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #6a00f4, #9d00ff);
    color: #fff;
    box-shadow: 0 6px 20px rgba(154, 0, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.4);
    outline: none;
}

.wxr-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(154, 0, 255, 0.45);
    background: linear-gradient(135deg, #7500d4, #6a6a6a);
}

.wxr-btn:disabled {
    background: #7e868e;
    cursor: not-allowed;
}

.wxr-integration-button-link {
    font-weight: 700;
    font-family: inherit;
    appearance: none;
    border: 2px solid #5616ea;
    background: #fff;
    color: #5616ea;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1.125rem;
    transition: 0.2s ease, color 0.2s ease;
    text-decoration: none;
    display: inline-block;
    text-align: center;
}

.wxr-integration-button-link:hover {
    background: #f5f5f5;
    transform: translateY(-1.5px);
}

/* â”€â”€ Headings / text â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-register-scope h2 {
    margin: 0 0 var(--wxr-sp-3);
    font-size: clamp(1.3rem, 2.3vw + 1rem, 2.1rem);
    font-weight: 700;
    line-height: 1.2;
}

.wxr-sub {
    font-size: clamp(0.9rem, 1vw + 0.75rem, 1.05rem);
    margin: 0 0 var(--wxr-sp-4);
    color: var(--wxr-c-grey-600);
}

/* â”€â”€ Inputs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-register-input-text {
    width: 100%;
    padding: var(--wxr-sp-3);
    margin-bottom: var(--wxr-sp-3);
    font-size: 1rem;
    font-weight: 600;
    color: #000000;
    border: 1px solid #ced4da;
    border-radius: var(--wxr-r-s);
}

.wxr-register-input-text:disabled { cursor: not-allowed; }

.wxr-register-input-text:focus {
    border-color: var(--wxr-c-primary);
    outline: none;
    box-shadow: 0 0 0 3px #5616ea33;
}

.wxr-input-error {
    border-color: #e74c3c !important;
}

.wxr-privacy-note {
    font-size: 0.8rem;
    color: var(--wxr-c-grey-800);
    font-style: italic;
}

/* â”€â”€ Inline spinner / errors â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-spin {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    border: 2px solid #ffffff;
    border-top-color: var(--wxr-c-primary);
    animation: wxr-spin 1s linear infinite;
}

.wxr-err {
    margin-top: var(--wxr-sp-3);
    color: var(--wxr-c-danger);
    font-weight: 600;
}

@keyframes wxr-spin {
    to { transform: rotate(360deg); }
}

/* â”€â”€ Customisation step (preview) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-preview-area {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 20px;
}

.wxr-preview-header-text {
    text-align: center;
}

.wxr-preview-card {
    display: flex;
    justify-content: space-between;
    gap: var(--wxr-sp-4);
}

.wxr-user-settings {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
}

.wxr-user-settings input[type="color"] {
    appearance: none;
    width: 34px;
    height: 34px;
    border-radius: 20%;
    padding: 2px;
    border: 1px solid var(--wxr-c-grey-300);
    cursor: pointer;
    background: none;
    transition: transform 0.3s;
}

.wxr-user-settings input[type="color"]:hover {
    transform: scale(1.12);
}

.wxr-user-settings input[type="color"]::-webkit-color-swatch {
    border: 0;
    border-radius: 20%;
}

.wxr-user-settings input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    height: 6px;
    background: #dddddd;
    border-radius: 3px;
    margin-top: 0.4rem;
}

.wxr-user-settings input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--wxr-c-primary);
    cursor: pointer;
    -webkit-transition: background 0.3s, transform 0.3s;
    transition: background 0.3s, transform 0.3s;
}

.wxr-user-settings input[type="range"]::-webkit-slider-thumb:hover {
    background: var(--wxr-c-primary-dark);
    transform: scale(1.1);
}

/* â”€â”€ Control groups (settings rows) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-control-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
}

.wxr-control-group:last-child { margin-bottom: 0; }

.wxr-color-picker-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.wxr-border-radius-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.wxr-widget-setting-title {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    text-align: left;
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 500;
    color: #444;
    margin-bottom: 0;
}

/* â”€â”€ Logo / Widget icon upload control â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-logo-upload {
    display: flex;
    align-items: center;
    gap: 8px;
}

.wxr-logo-preview {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--wxr-c-grey-300);
    background: #fff;
}

.wxr-logo-upload-btn {
    background: #fff;
    color: var(--wxr-c-primary);
    border: 1px solid var(--wxr-c-primary);
    border-radius: var(--wxr-r-s);
    padding: 6px 12px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.wxr-logo-upload-btn:hover {
    background: var(--wxr-c-primary);
    color: #fff;
}

.wxr-logo-remove-btn {
    background: transparent;
    color: var(--wxr-c-grey-600);
    border: none;
    cursor: pointer;
    padding: 4px 6px;
    font-size: 1rem;
    line-height: 1;
    border-radius: 4px;
    transition: color 0.2s, background 0.2s;
}

.wxr-logo-remove-btn:hover {
    color: var(--wxr-c-danger);
    background: rgba(220, 53, 69, 0.08);
}

/* â”€â”€ Radio buttons (pulsing on/off) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-radio-buttons {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    gap: 15px;
}

.wxr-radio-buttons-content {
    display: flex;
    align-items: center;
    margin: 10px 0;
    width: 80px;
}

.wxr-radio-buttons-content input[type="radio"] {
    display: none;
}

.wxr-radio-buttons-content label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #444;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    position: relative;
    padding-left: 24px;
}

.wxr-radio-buttons-content label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    border: 1.5px solid #5616ea;
    border-radius: 4px;
    background: transparent;
    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
    box-sizing: border-box;
}

.wxr-radio-buttons-content input[type="radio"]:checked + label::before {
    background-color: #5616ea;
    border-color: #4a14d6;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}

.wxr-radio-buttons-content input[type="radio"]:checked + label {
    color: #4a14d6;
}

/* â”€â”€ Divider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-divider {
    width: 0.5px;
    background-color: #ccc;
}

/* â”€â”€ Widget preview (chat window mockup) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-chat-widget-icon {
    display: flex;
    justify-content: center;
    align-items: center;
}

@keyframes wxr-pulse {
    0%   { transform: scale(1); }
    50%  { transform: scale(1.1); }
    100% { transform: scale(1); }
}

.wxr-pulsing {
    animation: wxr-pulse 2s infinite;
}

.wxr-chat-window {
    font-family: "DM Sans", sans-serif;
    font-weight: normal;
    width: 400px;
    height: 550px;
    background-color: transparent;
    border: none;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex !important;
    flex-direction: column;
    z-index: 10000000 !important;
    opacity: 1;
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.wxr-chat-header {
    background-color: transparent;
    color: white;
    padding: 10px;
    padding-right: 15px;
    border-radius: 10px 10px 0 0;
    display: flex;
    flex-direction: column;
}

.wxr-chat-header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.wxr-chat-header-title img {
    vertical-align: middle;
}

.wxr-logo-message-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.wxr-chat-body {
    flex: 1 1;
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: white;
    text-align: left;
}

.wxr-chat-body p {
    margin: 5px;
    width: 80%;
}

.wxr-chat-footer {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: white;
    gap: 10px;
}

.wxr-powered-by {
    display: flex;
    justify-content: center;
}

.wxr-powered-by-text {
    font-size: 10px;
    color: rgb(146, 146, 146);
    cursor: pointer;
    text-decoration: underline;
}

.wxr-input-send-container {
    display: flex;
    border-top: 1px solid #ccc;
    padding-top: 10px;
}

.wxr-chat-footer input {
    flex: 1 1;
    padding: 7px;
    border: 1px solid #ccc;
    border-radius: 8px;
    outline: none;
    font-size: 16px;
}

.wxr-chat-footer button {
    margin-left: 10px;
    padding: 5px 10px;
    padding-right: 13px;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.wxr-chat-footer button:hover {
    background-color: #0595d3;
}

.wxr-onboarding-chat-title {
    font-weight: 700;
}

.wxr-onboarding-widget-close-button {
    font-size: 1.5rem;
    line-height: 1;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    margin: 0;
    padding: 0;
    outline: none;
    transition: all 0.3s ease;
}

.wxr-onboarding-widget-close-button:hover {
    transform: translateY(-1px);
}

.wxr-onboarding-send-message {
    padding: 10px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
    margin-left: 5px !important;
}

/* â”€â”€ Subscription section (plans) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-subscription-section {
    text-align: center;
    max-width: 1100px;
    margin: 0 auto;
    padding: var(--wxr-sp-4) var(--wxr-sp-3);
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 15px;
    background: linear-gradient(to right, #ffffff, var(--wxr-c-grey-100));
    border-radius: var(--wxr-r-m);
}

.wxr-plan-wait-card {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.wxr-plan-slider-wrapper {
    padding-inline: var(--wxr-sp-2);
    padding-top: 18px;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
}

.wxr-plan-slider-wrapper::-webkit-scrollbar { height: 8px; }
.wxr-plan-slider-wrapper::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.wxr-plan-slider-wrapper::-webkit-scrollbar-thumb { background: #c4c4c4; border-radius: 4px; }
.wxr-plan-slider-wrapper::-webkit-scrollbar-thumb:hover { background: #a0a0a0; }

@media (max-width: 480px) {
    .wxr-plan-slider-wrapper::-webkit-scrollbar { height: 0; }
}

.wxr-plan-slider {
    display: flex;
    gap: var(--wxr-sp-3);
    width: max-content;
}

.wxr-plan-card {
    flex: 0 0 280px;
    min-width: 280px;
    scroll-snap-align: center;
    background: #ffffff;
    border: 2px solid #bdb4f1;
    border-radius: var(--wxr-r-m);
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: var(--wxr-sp-3) var(--wxr-sp-3);
    transition: transform 0.3s, box-shadow 0.3s;
    box-shadow: none;
    margin-bottom: 10px;
    position: relative;
}

.wxr-plan-badge {
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    background: #5616ea;
    color: #ffffff;
    padding: 6px 12px;
    font-size: 0.90rem;
    font-weight: 600;
    line-height: 1;
    border-radius: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    white-space: nowrap;
}

.wxr-plan-card h3 {
    margin: 0 0 var(--wxr-sp-2);
    font-size: clamp(1.25rem, 1vw + 1rem, 1.7rem);
    color: var(--wxr-c-primary);
}

.wxr-plan-features {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-bottom: 0.2rem;
}

.wxr-plan-features li {
    font-size: 1rem;
    margin-bottom: 0.8rem;
    color: #333;
}

.wxr-plan-features svg {
    margin-bottom: -0.5px;
}

.wxr-plan-icons-included {
    margin-right: 0.5rem;
    color: #5616ea;
}

.wxr-plan-icons-not-included {
    margin-right: 0.5rem;
    color: #e51616;
}

.wxr-feature-platform-icon {
    height: 18px;
    width: auto;
    margin-left: 10px;
    vertical-align: middle;
    position: relative;
    top: 0px;
    object-fit: contain;
}

/* Feature rows that carry platform icons (Messaging / Sync data):
   keep the checkmark, label and logos on one centered line, wrapping
   gracefully on narrow cards instead of overflowing. */
.wxr-plan-feature-icons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 4px;
}

/* â”€â”€ Tooltips on platform icons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-icon-tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 10px;
}

.wxr-icon-tooltip-wrapper .wxr-feature-platform-icon {
    margin-left: 0;
    transition: transform 0.2s ease, filter 0.2s ease;
}

.wxr-icon-tooltip-wrapper:hover .wxr-feature-platform-icon {
    transform: scale(1.15) translateY(-2px);
    filter: drop-shadow(0 4px 8px rgba(86, 22, 234, 0.25));
}

.wxr-icon-tooltip {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%) translateY(8px);
    padding: 10px 14px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
    border-radius: 10px;
    box-shadow:
        0 10px 40px rgba(0, 0, 0, 0.25),
        0 0 0 1px rgba(255, 255, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    opacity: 0;
    visibility: hidden;
    transition:
        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        visibility 0.3s;
    z-index: 100;
    pointer-events: none;
    backdrop-filter: blur(10px);
    letter-spacing: 0.3px;
}

.wxr-icon-tooltip::before {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, transparent 50%, #16213e 50%);
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 3px 0;
}

.wxr-icon-tooltip-wrapper:hover .wxr-icon-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
}

.wxr-icon-tooltip.wxr-facebook {
    background: linear-gradient(135deg, #1877f2 0%, #0d65d9 100%);
}
.wxr-icon-tooltip.wxr-facebook::before {
    background: linear-gradient(135deg, transparent 50%, #0d65d9 50%);
}

.wxr-icon-tooltip.wxr-instagram {
    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}
.wxr-icon-tooltip.wxr-instagram::before {
    background: linear-gradient(135deg, transparent 50%, #bc1888 50%);
}

.wxr-icon-tooltip.wxr-whatsapp {
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
}
.wxr-icon-tooltip.wxr-whatsapp::before {
    background: linear-gradient(135deg, transparent 50%, #128c7e 50%);
}

.wxr-icon-tooltip.wxr-google-drive {
    background: linear-gradient(135deg, #4285f4 0%, #34a853 50%, #fbbc05 100%);
}
.wxr-icon-tooltip.wxr-google-drive::before {
    background: linear-gradient(135deg, transparent 50%, #fbbc05 50%);
}

.wxr-icon-tooltip.wxr-onedrive {
    background: linear-gradient(135deg, #0078d4 0%, #005a9e 100%);
}
.wxr-icon-tooltip.wxr-onedrive::before {
    background: linear-gradient(135deg, transparent 50%, #005a9e 50%);
}

.wxr-icon-tooltip.wxr-notion {
    background: linear-gradient(135deg, #2f2f2f 0%, #000000 100%);
}
.wxr-icon-tooltip.wxr-notion::before {
    background: linear-gradient(135deg, transparent 50%, #000000 50%);
}

.wxr-icon-tooltip.wxr-telegram {
    background: linear-gradient(135deg, #2aabee 0%, #229ed9 100%);
}
.wxr-icon-tooltip.wxr-telegram::before {
    background: linear-gradient(135deg, transparent 50%, #229ed9 50%);
}

.wxr-icon-tooltip.wxr-slack {
    background: linear-gradient(135deg, #611f69 0%, #4a154b 100%);
}
.wxr-icon-tooltip.wxr-slack::before {
    background: linear-gradient(135deg, transparent 50%, #4a154b 50%);
}

/* â”€â”€ Plan CTA button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-wix-plan-button {
    width: 100%;
    gap: 0.5em;
    padding: 0.65em 1.5em;
    font-weight: 600;
    font-size: 18px;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);
    color: #fff;
    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.4);
    text-align: center;
    position: relative;
    z-index: 1;
}

.wxr-wix-plan-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
    pointer-events: none;
}

.wxr-wix-plan-button:hover:not(:disabled)::before { opacity: 1; }

.wxr-wix-plan-button:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);
}

.wxr-wix-plan-button:disabled {
    background: #7e868e;
    cursor: not-allowed;
}

/* â”€â”€ Pricing indicators (mobile carousel dots) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-pricing-indicators {
    display: flex;
    justify-content: center;
    gap: var(--wxr-sp-2);
    margin-top: var(--wxr-sp-4);
}

.wxr-indicator {
    width: 40px;
    height: 8px;
    border: 1px solid var(--wxr-c-grey-300);
    border-radius: var(--wxr-r-s);
    background: transparent;
    transition: background 0.3s, border-color 0.3s;
}

.wxr-indicator.wxr-active {
    background: var(--wxr-c-primary);
    border-color: var(--wxr-c-primary);
}

.wxr-cancel-note {
    font-size: 0.85rem;
    color: var(--wxr-c-grey-600);
    margin-top: 15px;
    padding-inline: var(--wxr-sp-2);
}

/* â”€â”€ Billing toggle (Monthly / Yearly) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-billing-toggle {
    position: relative;
    display: inline-flex;
    border: 1px solid #dddddd;
    border-radius: 8px;
    overflow: hidden;
    background: #f1f1f1;
    padding: 4px;
    outline: none;
}

.wxr-billing-thumb {
    position: absolute;
    top: 3px;
    left: 3px;
    width: calc(50% - 3px);
    height: calc(100% - 6px);
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    z-index: 0;
}

.wxr-billing-toggle[data-cycle="YEAR"] .wxr-billing-thumb {
    left: 50%;
}

.wxr-billing-toggle button {
    position: relative;
    z-index: 1;
    flex: 1 1;
    padding: 5px 20px;
    padding-top: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #969696;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    text-align: center;
}

.wxr-billing-toggle button.wxr-active {
    color: #2f2f2f;
}

/* â”€â”€ Desktop layout for plans â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
@media (min-width: 920px) {
    .wxr-plan-slider-wrapper {
        overflow: visible;
        padding: 0;
        padding-top: 18px;
    }

    .wxr-plan-slider {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(3, 1fr);
        gap: var(--wxr-sp-4);
    }

    .wxr-plan-card {
        flex: 0 0 auto;
        min-width: unset;
        max-width: 100%;
        scroll-snap-align: unset;
    }

    .wxr-pricing-indicators {
        display: none;
    }
}

/* â”€â”€ Completion / "live" step â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-complete-title {
    border-bottom: 1px solid var(--wxr-c-grey-300);
    padding-bottom: 20px;
    font-size: 1.5rem;
}

.wxr-live-highlight {
    background: var(--wxr-c-primary);
    color: #ffffff;
    border-radius: 1rem;
    font: 600 clamp(1rem, 3vw + 0.4rem, 1.4rem) / 1 inherit;
    padding: 12px;
    padding-top: 3px;
    padding-bottom: 8px;
}

.wxr-portal-button-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.wxr-after-setup-links {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.wxr-integration-complete-content {
    display: flex;
    gap: 8px;
    justify-content: center;
    font-size: 1.125rem;
    font-weight: 600;
    align-items: center;
}

/* â”€â”€ Back-button header (positions BackButton's .lp-back-btn) */
.wxr-header-back-button {
    position: relative;
    text-align: center;
    margin-bottom: 15px;
}

.wxr-header-back-button h2 {
    margin: 0;
    font-size: 1.25rem;
}

/* The shared <BackButton /> component renders className="lp-back-btn".
   Re-declare its styling here, scoped to the WixRegister header so it
   continues to look right when used inside this page only. */
.wxr-header-back-button .lp-back-btn,
.wxr-lp-back-btn {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);
    border: none;
    outline: none;
    border-radius: 50%;
    font-size: 1.125rem;
    font-weight: 600;
    color: white;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,.12);
    transition: transform .25s, box-shadow .25s;
}

.wxr-header-back-button .lp-back-btn:hover,
.wxr-lp-back-btn:hover {
    transform: translateY(-50%) translateX(-2px);
    box-shadow: 0 6px 16px rgba(0,0,0,.16);
}

.wxr-header-back-button .lp-back-btn:active,
.wxr-lp-back-btn:active {
    transform: translateY(-50%) translateX(0);
    box-shadow: 0 3px 8px rgba(0,0,0,.12);
}

/* â”€â”€ Loading container â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 200px;
}

.wxr-spinner {
    margin-top: 100px;
    border: 8px solid #f3f3f3;
    border-top: 8px solid #5616ea;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: wxr-spin 1.1s linear infinite;
}

/* â”€â”€ Misc small bits â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-chatbot-loading-container {
    display: flex;
    flex-direction: column;
    color: #5616ea;
    font-weight: 600;
    font-size: 1.1rem;
    margin-top: 10px;
}

.wxr-wix-plan-price {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
}

.wxr-wix-plan-month {
    margin: 0;
    font-size: 13px;
    color: grey;
    margin-top: 2px;
    font-style: italic;
}

/* â”€â”€ Yearly cross-out price block â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-yearly-crossout {
    display: flex;
    align-items: center;
    gap: 12px;
}

.wxr-yearly-crossout .wxr-old-price {
    text-decoration: line-through;
    text-decoration-thickness: 1.5px;
    text-decoration-color: #5616ea;
    opacity: .8;
    font-size: 18px;
}

.wxr-yearly-crossout .wxr-deal-tag {
    display: flex;
    align-items: center;
    padding: 7px;
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: .75rem;
    font-weight: 700;
    border-radius: 10px;
    background: #5616ea;
    color: white;
    border: none;
    text-align: center;
    height: 80%;
}

/* â”€â”€ Free-plan link â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-free-plan-link { margin: 0; }

.wxr-free-plan-link-button {
    background: none;
    border: none;
    color: #5616ea;
    cursor: pointer;
    padding: 0;
    font-size: 0.85rem;
    text-decoration: underline;
    margin: 0;
}

.wxr-free-plan-link-button:hover { opacity: 0.8; }

/* â”€â”€ Price cross-fade swap â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.wxr-price-swap {
    position: relative;
    min-height: 60px;
    will-change: opacity, transform;
}

.wxr-price-swap .wxr-pane {
    position: absolute;
    inset: 0;
    opacity: 0;
    transform: translateY(8px);
    transition:
        opacity var(--wxr-swap-dur-out) cubic-bezier(.22,.7,.18,1),
        transform var(--wxr-swap-dur-out) cubic-bezier(.22,.7,.18,1);
    pointer-events: none;
}

.wxr-price-swap .wxr-pane.wxr-show {
    opacity: 1;
    transform: translateY(0);
    transition:
        opacity var(--wxr-swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--wxr-swap-delay-in),
        transform var(--wxr-swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--wxr-swap-delay-in);
    pointer-events: auto;
}

.wxr-price-swap .wxr-pane .wxr-deal-tag {
    transform: scale(.94);
    opacity: 0;
    transition:
        transform 260ms cubic-bezier(.22,.7,.18,1) calc(var(--wxr-swap-delay-in) + 80ms),
        opacity   260ms cubic-bezier(.22,.7,.18,1) calc(var(--wxr-swap-delay-in) + 80ms);
}

.wxr-price-swap .wxr-pane.wxr-show .wxr-deal-tag {
    transform: scale(1);
    opacity: 1;
}

.wxr-price-swap .wxr-pane .wxr-old-price {
    opacity: 0;
    transition: opacity 280ms ease calc(var(--wxr-swap-delay-in) + 60ms);
}
.wxr-price-swap .wxr-pane.wxr-show .wxr-old-price {
    opacity: .9;
}

@media (prefers-reduced-motion: reduce) {
    .wxr-price-swap .wxr-pane,
    .wxr-price-swap .wxr-pane.wxr-show,
    .wxr-price-swap .wxr-pane .wxr-deal-tag,
    .wxr-price-swap .wxr-pane .wxr-old-price {
        transition: none !important;
        transform: none !important;
        opacity: 1 !important;
    }
}

/* â”€â”€ Mobile overrides â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
@media (max-width: 480px) {
    .wxr-preview-card {
        flex-direction: column;
    }

    .wxr-wrapper {
        padding: var(--wxr-safe-top) var(--wxr-sp-3) var(--wxr-safe-bottom);
    }

    .wxr-card {
        padding: var(--wxr-sp-3) var(--wxr-sp-3);
    }

    .wxr-chatbot-card {
        padding: var(--wxr-sp-3) var(--wxr-sp-2);
    }

    .wxr-preview-parent-container {
        padding: var(--wxr-sp-3) var(--wxr-sp-2);
    }

    .wxr-plan-card {
        flex: 0 0 260px;
        min-width: 260px;
    }

    .wxr-plan-card p { margin: 2px; }

    .wxr-plan-card h3 {
        margin: 0;
        font-size: 1.5rem;
    }

    .wxr-plan-card:hover {
        transform: translateY(0);
        box-shadow: none !important;
    }

    .wxr-cancel-note {
        margin: 0;
        margin-top: 20px;
    }

    .wxr-divider {
        width: 100%;
        height: 1px;
        background-color: #ccc;
    }

    .wxr-btn {
        max-width: 450px;
        font-size: 1.1875rem;
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .wxr-live-highlight {
        padding: 0.25em 0.6em;
    }

    .wxr-header-back-button {
        margin-bottom: 18px;
    }

    .wxr-card-button-wrapper,
    .wxr-chatbot-card,
    .wxr-preview-parent-container,
    .wxr-subscription-section {
        max-height: calc(100svh - var(--wxr-safe-top) - 2 * var(--wxr-sp-3));
        max-height: calc(100svh - var(--wxr-safe-top) - var(--wxr-safe-bottom) - 2 * var(--wxr-sp-3));
    }

    .wxr-logo-register-site {
        width: clamp(80px, 2vw, 50px);
    }

    .wxr-chat-window {
        max-width: 100%;
        max-height: 450px;
    }
}


/* -------------------------------------------------------------
   Step 4 — Notification preferences (engagement)
   ------------------------------------------------------------- */
.wxr-register-scope .wxr-engagement-card {
    background: #fff;
    border: 1px solid #e8e8ee;
    border-radius: var(--wxr-r-m);
    padding: var(--wxr-sp-4) var(--wxr-sp-3);
    padding-top: 18px;
    padding-bottom: 15px;
    box-shadow: 0 6px 24px rgba(86, 22, 234, 0.06);
    width: 100%;
    box-sizing: border-box;
}

.wxr-register-scope .wxr-notify-info-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #5616ea14;
    border-left: 4px solid #5616ea;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 18px;
}

.wxr-register-scope .wxr-notify-info-box p {
    margin: 0;
    font-size: 13px;
    color: #2a2a35;
    line-height: 1.45;
}

.wxr-register-scope .wxr-notify-info-icon {
    color: #5616ea;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
}

/* ── Matrix ─────────────────────────────────────────────── */
.wxr-register-scope .wxr-notify-matrix {
    background: #fafaff;
    border: 1px solid #ececf5;
    border-radius: 12px;
    overflow: hidden;
}

.wxr-register-scope .wxr-notify-matrix-row {
    display: grid;
    grid-template-columns: minmax(0, 2.4fr) repeat(2, minmax(80px, 1fr));
    align-items: center;
    gap: 4px;
    padding: 10px 12px;
    border-bottom: 1px solid #ececf5;
}

.wxr-register-scope .wxr-notify-matrix-row:last-child {
    border-bottom: none;
}

.wxr-register-scope .wxr-notify-matrix-header {
    background: #f3f1fb;
    padding: 10px 12px;
}

.wxr-register-scope .wxr-notify-matrix-row-highlight {
    background: rgba(86, 22, 234, 0.05);
}

.wxr-register-scope .wxr-notify-matrix-event-col {
    min-width: 0;
    padding-right: 6px;
}

.wxr-register-scope .wxr-notify-matrix-channel-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 4px;
}

.wxr-register-scope .wxr-notify-matrix-channel-icon {
    font-size: 14px;
    color: #5616ea;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.wxr-register-scope .wxr-notify-matrix-channel-icon-brand {
    line-height: 0;
}

.wxr-register-scope .wxr-notify-matrix-channel-label-row {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11.5px;
    color: #4a4a55;
    font-weight: 600;
}

.wxr-register-scope .wxr-notify-matrix-channel-label {
    white-space: nowrap;
}

.wxr-register-scope .wxr-notify-matrix-coming-soon {
    background: #ffefc7;
    color: #8a5c00;
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    padding: 1px 5px;
    border-radius: 6px;
    letter-spacing: 0.3px;
}

.wxr-register-scope .wxr-notify-matrix-event-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1a1a;
}

.wxr-register-scope .wxr-notify-matrix-event-icon {
    color: #5616ea;
    font-size: 13px;
    width: 16px;
    text-align: center;
    flex-shrink: 0;
}

.wxr-register-scope .wxr-notify-matrix-event-desc {
    font-size: 11.5px;
    color: #6a6a78;
    margin-top: 2px;
    text-align: left;
    line-height: 1.35;
}

/* ── More channels, set up later in the portal ─────────────
   Informational strip (dashed border = not interactive here),
   visually previewing Telegram & Slack as notification channels. */
.wxr-register-scope .wxr-notify-portal-channels {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-top: 12px;
    padding: 11px 14px;
    background: #fafaff;
    border: 1px dashed #d8d0f3;
    border-radius: 12px;
}

.wxr-register-scope .wxr-notify-portal-channels-label {
    font-size: 12.5px;
    font-weight: 600;
    color: #5616ea;
}

.wxr-register-scope .wxr-notify-portal-chips {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.wxr-register-scope .wxr-notify-portal-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 11px;
    background: #ffffff;
    border: 1px solid #ececf5;
    border-radius: 999px;
    font-size: 12.5px;
    font-weight: 600;
    color: #4a4a55;
}

/* ── Recipients block ──────────────────────────────────── */
.wxr-register-scope .wxr-notify-recipients {
    margin-top: 18px;
    padding: 16px 16px 14px;
    background: #fafaff;
    border: 1px solid #ececf5;
    border-radius: 12px;
    text-align: left;
}

.wxr-register-scope .wxr-notify-recipients-heading {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 15px;
}

.wxr-register-scope .wxr-notify-spam-warning {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #fff8e1;
    border: 1px solid #ffe082;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 12px;
}

.wxr-register-scope .wxr-notify-spam-warning p {
    margin: 0;
    font-size: 12px;
    color: #6a4f00;
    line-height: 1.4;
}

.wxr-register-scope .wxr-notify-spam-warning-icon {
    color: #c79100;
    font-size: 13px;
    margin-top: 2px;
    flex-shrink: 0;
}

.wxr-register-scope .wxr-notify-emails-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
}

.wxr-register-scope .wxr-notify-email-row {
    width: 100%;
    text-align: left;
}

.wxr-register-scope .wxr-notify-add-email-btn {
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    outline: none;
    width: 50px;
    display: block;
    margin-right: auto;
    text-align: left;
    padding: 0;
    margin-top: 10px;
    color: #5616ea;
    border-radius: 10px;
    font-size: 26px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.wxr-register-scope .wxr-notify-add-email-btn:hover {
    transform: translateY(-2px);
}

.wxr-register-scope .wxr-notify-error {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fdecea;
    border: 1px solid #f5c6c2;
    color: #7a1c1c;
    font-size: 12.5px;
    border-radius: 8px;
    padding: 8px 10px;
    margin-top: 10px;
}

@media (max-width: 768px) {
    .wxr-register-scope .wxr-engagement-card {
        padding: 18px;
    }
    .wxr-register-scope .wxr-notify-matrix-row {
        grid-template-columns: minmax(0, 2fr) repeat(2, minmax(60px, 1fr));
        gap: 2px;
        padding: 8px 8px;
    }
    .wxr-register-scope .wxr-notify-matrix-event-title {
        font-size: 12.5px;
    }
    .wxr-register-scope .wxr-notify-matrix-event-desc {
        font-size: 11px;
    }
    .wxr-register-scope .wxr-notify-matrix-channel-label {
        font-size: 10px;
    }
    .wxr-register-scope .wxr-notify-matrix-channel-icon {
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WixRegister.css"],"names":[],"mappings":"AAAA;;;;;;;;;8DAS8D;;AAE9D,mFAAmF;AACnF;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;;IAE/B,6BAA6B;IAC7B,+BAA+B;IAC/B,sDAAsD;;IAEtD,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;;IAE5B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI;QACI,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA,6JAA6J;AAC7J;;;;IAII,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,wIAAwI;AACxI;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mEAAmE;IACnE,0EAA0E;IAC1E,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,0JAA0J;AAC1J;;;IAGI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA,8IAA8I;AAC9I;;;;IAII,6FAA6F;IAC7F,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ;;;;;;;;KAQC;IACD,gCAAgC;IAChC,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,OAAO,6CAA6C,EAAE;IACtD,OAAO,+CAA+C,EAAE;AAC5D;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA,mJAAmJ;AACnJ;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,qDAAqD;IACrD,WAAW;IACX,6CAA6C;IAC7C,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,iJAAiJ;AACjJ;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,sKAAsK;AACtK;IACI,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD;IACI,kCAAkC;IAClC,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,iIAAiI;AACjI;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,uHAAuH;AACvH;IACI,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,mDAA2C;IAA3C,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA,mHAAmH;AACnH;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,gCAAgC,gBAAgB,EAAE;;AAElD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA,0GAA0G;AAC1G;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;IACtC,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uCAAuC;IACvC,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA,mHAAmH;AACnH;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,oFAAoF;IACpF,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA,iKAAiK;AACjK;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,yGAAyG;AACzG;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,OAAO,mBAAmB,EAAE;IAC5B,OAAO,qBAAqB,EAAE;IAC9B,OAAO,mBAAmB,EAAE;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,4BAA4B;IAC5B,wCAAwC;IACxC,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA,uHAAuH;AACvH;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,qEAAqE;IACrE,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA,8CAA8C,WAAW,EAAE;AAC3D,oDAAoD,mBAAmB,EAAE,kBAAkB,EAAE;AAC7F,oDAAoD,mBAAmB,EAAE,kBAAkB,EAAE;AAC7F,0DAA0D,mBAAmB,EAAE;;AAE/E;IACI,8CAA8C,SAAS,EAAE;AAC7D;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,wCAAwC;IACxC,2CAA2C;IAC3C,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;uDAEuD;AACvD;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA,2HAA2H;AAC3H;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,uCAAuC;IACvC,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,2CAA2C;IAC3C,kBAAkB;IAClB,6DAA6D;IAC7D,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB;;;8CAG0C;IAC1C,UAAU;IACV,kBAAkB;IAClB;;;uBAGmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,iEAAiE;IACjE,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,oGAAoG;AACxG;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,0EAA0E;AAC9E;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA,iJAAiJ;AACjJ;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,qDAAqD;IACrD,mEAAmE;IACnE,WAAW;IACX,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,mEAAmE;IACnE,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;AACxB;;AAEA,oDAAoD,UAAU,EAAE;;AAEhE;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,6FAA6F;AAC7F;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uCAAuC;IACvC,6BAA6B;IAC7B,uBAAuB;IACvB,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA,6GAA6G;AAC7G;IACI,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kDAAkD;IAClD,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,mDAAmD;IACnD,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,+HAA+H;AAC/H;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,qCAAqC;QACrC,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,+HAA+H;AAC/H;IACI,8CAA8C;IAC9C,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,uDAAuD;IACvD,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oEAAoE;AACpE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;;6DAE6D;AAC7D;;IAEI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mEAAmE;IACnE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;;IAEI,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;;IAEI,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA,6IAA6I;AAC7I;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wCAAwC;AAC5C;;AAEA,iJAAiJ;AACjJ;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,uHAAuH;AACvH;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA,mJAAmJ;AACnJ,sBAAsB,SAAS,EAAE;;AAEjC;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;AACb;;AAEA,mCAAmC,YAAY,EAAE;;AAEjD,qIAAqI;AACrI;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,0BAA0B;IAC1B;;oEAEgE;IAChE,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB;;4FAEwF;IACxF,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;;wFAEoF;AACxF;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oEAAoE;AACxE;AACA;IACI,WAAW;AACf;;AAEA;IACI;;;;QAII,2BAA2B;QAC3B,0BAA0B;QAC1B,qBAAqB;IACzB;AACJ;;AAEA,+IAA+I;AAC/I;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,mEAAmE;IACvE;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA,mBAAmB,WAAW,EAAE;;IAEhC;QACI,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;;QAII,oEAAoE;QACpE,6FAA6F;IACjG;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;AAGA;;kEAEkE;AAClE;IACI,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,wCAAwC;IACxC,iBAAiB;IACjB,oBAAoB;IACpB,8CAA8C;IAC9C,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA,8DAA8D;AAC9D;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oEAAoE;IACpE,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;mEAEmE;AACnE;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,6DAA6D;AAC7D;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,kEAAkE;QAClE,QAAQ;QACR,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* =========================================================\r\n   WixRegister.css\r\n   Standalone, scoped stylesheet for WixRegister.js.\r\n   All class names are prefixed with `wxr-` to avoid colliding\r\n   with global / shared styles. Visual output is intended to\r\n   match the previous combination of:\r\n     - LandingPageRegister.css\r\n     - components/widgetPreview.css\r\n     - components/widgetCustomizationTab.css\r\n   ========================================================= */\r\n\r\n/* â”€â”€ CSS variables (scoped to the WixRegister root) â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-register-scope {\r\n    --wxr-c-primary:        #5616ea;\r\n    --wxr-c-primary-dark:   #4620c7;\r\n    --wxr-c-grey-100:       #faf9ff;\r\n    --wxr-c-grey-300:       #dbd9e4;\r\n    --wxr-c-grey-600:       #555;\r\n    --wxr-c-grey-800:       #333;\r\n    --wxr-c-danger:         #dc3545;\r\n\r\n    --wxr-r-s:              .5rem;\r\n    --wxr-r-m:              .875rem;\r\n    --wxr-shadow:           0 10px 24px rgba(0, 0, 0, .15);\r\n\r\n    --wxr-sp-1:             .5rem;\r\n    --wxr-sp-2:             .75rem;\r\n    --wxr-sp-3:             1rem;\r\n    --wxr-sp-4:             1.5rem;\r\n    --wxr-sp-5:             2rem;\r\n    --wxr-safe-top:         4rem;\r\n    --wxr-safe-bottom:      35px;\r\n\r\n    --wxr-swap-dur-out:     280ms;\r\n    --wxr-swap-dur-in:      520ms;\r\n    --wxr-swap-delay-in:    120ms;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .wxr-register-scope {\r\n        --wxr-sp-3: 1.125rem;\r\n        --wxr-sp-4: 2rem;\r\n        --wxr-sp-5: 2.75rem;\r\n    }\r\n}\r\n\r\n/* â”€â”€ Scoped reset â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-register-scope,\r\n.wxr-register-scope *,\r\n.wxr-register-scope *::before,\r\n.wxr-register-scope *::after {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.wxr-register-scope {\r\n    font-family: \"DM Sans\", sans-serif;\r\n}\r\n\r\n.wxr-register-scope img {\r\n    display: block;\r\n    max-width: 100%;\r\n}\r\n\r\n/* â”€â”€ Wrapper / page chrome â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-wrapper {\r\n    height: 100vh;\r\n    height: 100svh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: var(--wxr-safe-top) var(--wxr-sp-4) var(--wxr-safe-bottom);\r\n    background: linear-gradient(120deg, var(--wxr-c-primary) 0%, #320661 100%);\r\n    position: relative;\r\n}\r\n\r\n.wxr-logo-register-site {\r\n    position: fixed;\r\n    z-index: 5;\r\n    top: var(--wxr-sp-3);\r\n    left: var(--wxr-sp-3);\r\n    width: clamp(150px, 2vw, 50px);\r\n}\r\n\r\n.wxr-step-ind {\r\n    position: absolute;\r\n    top: var(--wxr-sp-3);\r\n    right: var(--wxr-sp-4);\r\n    color: #ffffff;\r\n    font-weight: 500;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n/* â”€â”€ Steps slider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-steps-wrapper,\r\n.wxr-steps-slider,\r\n.wxr-step-slide {\r\n    height: 100%;\r\n}\r\n\r\n.wxr-steps-wrapper {\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n\r\n.wxr-steps-slider {\r\n    display: flex;\r\n    width: 100%;\r\n    transition: transform 0.5s ease;\r\n}\r\n\r\n.wxr-step-slide {\r\n    flex: 0 0 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding-inline: var(--wxr-sp-3);\r\n}\r\n\r\n/* â”€â”€ Cards / containers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-card-button-wrapper,\r\n.wxr-chatbot-card,\r\n.wxr-preview-parent-container,\r\n.wxr-subscription-section {\r\n    max-height: calc(100svh - var(--wxr-safe-top) - var(--wxr-safe-bottom) - 2 * var(--wxr-sp-4));\r\n    overflow: auto;\r\n    text-align: center;\r\n}\r\n\r\n.wxr-card,\r\n.wxr-chatbot-card,\r\n.wxr-preview-parent-container {\r\n    background: #ffffff;\r\n    border-radius: var(--wxr-r-m);\r\n    box-shadow: var(--wxr-shadow);\r\n}\r\n\r\n.wxr-card {\r\n    width: min(100%, 480px);\r\n    padding: 25px;\r\n    text-align: center;\r\n}\r\n\r\n.wxr-card.wxr-building {\r\n    position: relative;\r\n    background-color: #e1e5eb;\r\n    opacity: 0.95;\r\n    overflow: hidden;\r\n}\r\n\r\n.wxr-card.wxr-building::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 200%;\r\n    height: 200%;\r\n    background: conic-gradient(\r\n        transparent 0deg,\r\n        transparent 160deg,\r\n        rgba(94, 27, 255, 0.2) 190deg,\r\n        rgba(94, 27, 255, 0.5) 210deg,\r\n        #5616ea 230deg,\r\n        #9966ff 295deg,\r\n        #5d1cff 360deg\r\n    );\r\n    transform: translate(-50%, -50%);\r\n    animation: wxr-rotateBorder 3s linear infinite;\r\n    z-index: 0;\r\n}\r\n\r\n.wxr-card.wxr-building::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 8px;\r\n    left: 8px;\r\n    right: 8px;\r\n    bottom: 8px;\r\n    background: #ffffff;\r\n    border-radius: calc(var(--wxr-r-m) - 6px);\r\n    z-index: 0;\r\n}\r\n\r\n.wxr-card.wxr-building > * {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n@keyframes wxr-rotateBorder {\r\n    from { transform: translate(-50%, -50%) rotate(0deg); }\r\n    to   { transform: translate(-50%, -50%) rotate(360deg); }\r\n}\r\n\r\n.wxr-chatbot-card {\r\n    width: min(100%, 620px);\r\n    padding: var(--wxr-sp-4) var(--wxr-sp-3);\r\n    padding-top: 18px;\r\n    padding-bottom: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.wxr-preview-parent-container {\r\n    width: 100%;\r\n    max-width: 1000px;\r\n    padding: var(--wxr-sp-4) var(--wxr-sp-3);\r\n    padding-top: 18px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--wxr-sp-4);\r\n}\r\n\r\n.wxr-card-button-wrapper {\r\n    width: 100%;\r\n    max-width: 800px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n/* â”€â”€ Primary button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-btn {\r\n    width: 100%;\r\n    max-width: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.5em;\r\n    padding: 0.85em 1.5em;\r\n    font-weight: 600;\r\n    font-size: 1.0625rem;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    transition: all 0.3s ease;\r\n    background: linear-gradient(135deg, #6a00f4, #9d00ff);\r\n    color: #fff;\r\n    box-shadow: 0 6px 20px rgba(154, 0, 255, 0.3);\r\n    border: 1px solid rgba(255, 255, 255, 0.4);\r\n    outline: none;\r\n}\r\n\r\n.wxr-btn:hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 24px rgba(154, 0, 255, 0.45);\r\n    background: linear-gradient(135deg, #7500d4, #6a6a6a);\r\n}\r\n\r\n.wxr-btn:disabled {\r\n    background: #7e868e;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.wxr-integration-button-link {\r\n    font-weight: 700;\r\n    font-family: inherit;\r\n    appearance: none;\r\n    border: 2px solid #5616ea;\r\n    background: #fff;\r\n    color: #5616ea;\r\n    padding: 8px 14px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 1.125rem;\r\n    transition: 0.2s ease, color 0.2s ease;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    text-align: center;\r\n}\r\n\r\n.wxr-integration-button-link:hover {\r\n    background: #f5f5f5;\r\n    transform: translateY(-1.5px);\r\n}\r\n\r\n/* â”€â”€ Headings / text â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-register-scope h2 {\r\n    margin: 0 0 var(--wxr-sp-3);\r\n    font-size: clamp(1.3rem, 2.3vw + 1rem, 2.1rem);\r\n    font-weight: 700;\r\n    line-height: 1.2;\r\n}\r\n\r\n.wxr-sub {\r\n    font-size: clamp(0.9rem, 1vw + 0.75rem, 1.05rem);\r\n    margin: 0 0 var(--wxr-sp-4);\r\n    color: var(--wxr-c-grey-600);\r\n}\r\n\r\n/* â”€â”€ Inputs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-register-input-text {\r\n    width: 100%;\r\n    padding: var(--wxr-sp-3);\r\n    margin-bottom: var(--wxr-sp-3);\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    color: #000000;\r\n    border: 1px solid #ced4da;\r\n    border-radius: var(--wxr-r-s);\r\n}\r\n\r\n.wxr-register-input-text:disabled { cursor: not-allowed; }\r\n\r\n.wxr-register-input-text:focus {\r\n    border-color: var(--wxr-c-primary);\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px #5616ea33;\r\n}\r\n\r\n.wxr-input-error {\r\n    border-color: #e74c3c !important;\r\n}\r\n\r\n.wxr-privacy-note {\r\n    font-size: 0.8rem;\r\n    color: var(--wxr-c-grey-800);\r\n    font-style: italic;\r\n}\r\n\r\n/* â”€â”€ Inline spinner / errors â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-spin {\r\n    width: 1.2rem;\r\n    height: 1.2rem;\r\n    border-radius: 50%;\r\n    border: 2px solid #ffffff;\r\n    border-top-color: var(--wxr-c-primary);\r\n    animation: wxr-spin 1s linear infinite;\r\n}\r\n\r\n.wxr-err {\r\n    margin-top: var(--wxr-sp-3);\r\n    color: var(--wxr-c-danger);\r\n    font-weight: 600;\r\n}\r\n\r\n@keyframes wxr-spin {\r\n    to { transform: rotate(360deg); }\r\n}\r\n\r\n/* â”€â”€ Customisation step (preview) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-preview-area {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: flex-end;\r\n    gap: 20px;\r\n}\r\n\r\n.wxr-preview-header-text {\r\n    text-align: center;\r\n}\r\n\r\n.wxr-preview-card {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: var(--wxr-sp-4);\r\n}\r\n\r\n.wxr-user-settings {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.wxr-user-settings input[type=\"color\"] {\r\n    appearance: none;\r\n    width: 34px;\r\n    height: 34px;\r\n    border-radius: 20%;\r\n    padding: 2px;\r\n    border: 1px solid var(--wxr-c-grey-300);\r\n    cursor: pointer;\r\n    background: none;\r\n    transition: transform 0.3s;\r\n}\r\n\r\n.wxr-user-settings input[type=\"color\"]:hover {\r\n    transform: scale(1.12);\r\n}\r\n\r\n.wxr-user-settings input[type=\"color\"]::-webkit-color-swatch {\r\n    border: 0;\r\n    border-radius: 20%;\r\n}\r\n\r\n.wxr-user-settings input[type=\"range\"] {\r\n    -webkit-appearance: none;\r\n    width: 100%;\r\n    height: 6px;\r\n    background: #dddddd;\r\n    border-radius: 3px;\r\n    margin-top: 0.4rem;\r\n}\r\n\r\n.wxr-user-settings input[type=\"range\"]::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    background: var(--wxr-c-primary);\r\n    cursor: pointer;\r\n    transition: background 0.3s, transform 0.3s;\r\n}\r\n\r\n.wxr-user-settings input[type=\"range\"]::-webkit-slider-thumb:hover {\r\n    background: var(--wxr-c-primary-dark);\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* â”€â”€ Control groups (settings rows) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-control-group {\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.wxr-control-group:last-child { margin-bottom: 0; }\r\n\r\n.wxr-color-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.wxr-border-radius-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.wxr-widget-setting-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    white-space: nowrap;\r\n    text-align: left;\r\n    justify-content: flex-start;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #444;\r\n    margin-bottom: 0;\r\n}\r\n\r\n/* â”€â”€ Logo / Widget icon upload control â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-logo-upload {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.wxr-logo-preview {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    border: 1px solid var(--wxr-c-grey-300);\r\n    background: #fff;\r\n}\r\n\r\n.wxr-logo-upload-btn {\r\n    background: #fff;\r\n    color: var(--wxr-c-primary);\r\n    border: 1px solid var(--wxr-c-primary);\r\n    border-radius: var(--wxr-r-s);\r\n    padding: 6px 12px;\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background 0.2s, color 0.2s;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.wxr-logo-upload-btn:hover {\r\n    background: var(--wxr-c-primary);\r\n    color: #fff;\r\n}\r\n\r\n.wxr-logo-remove-btn {\r\n    background: transparent;\r\n    color: var(--wxr-c-grey-600);\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 4px 6px;\r\n    font-size: 1rem;\r\n    line-height: 1;\r\n    border-radius: 4px;\r\n    transition: color 0.2s, background 0.2s;\r\n}\r\n\r\n.wxr-logo-remove-btn:hover {\r\n    color: var(--wxr-c-danger);\r\n    background: rgba(220, 53, 69, 0.08);\r\n}\r\n\r\n/* â”€â”€ Radio buttons (pulsing on/off) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-radio-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n    gap: 15px;\r\n}\r\n\r\n.wxr-radio-buttons-content {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 10px 0;\r\n    width: 80px;\r\n}\r\n\r\n.wxr-radio-buttons-content input[type=\"radio\"] {\r\n    display: none;\r\n}\r\n\r\n.wxr-radio-buttons-content label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #444;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    position: relative;\r\n    padding-left: 24px;\r\n}\r\n\r\n.wxr-radio-buttons-content label::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 18px;\r\n    height: 18px;\r\n    border: 1.5px solid #5616ea;\r\n    border-radius: 4px;\r\n    background: transparent;\r\n    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.wxr-radio-buttons-content input[type=\"radio\"]:checked + label::before {\r\n    background-color: #5616ea;\r\n    border-color: #4a14d6;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.wxr-radio-buttons-content input[type=\"radio\"]:checked + label {\r\n    color: #4a14d6;\r\n}\r\n\r\n/* â”€â”€ Divider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-divider {\r\n    width: 0.5px;\r\n    background-color: #ccc;\r\n}\r\n\r\n/* â”€â”€ Widget preview (chat window mockup) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-chat-widget-icon {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n@keyframes wxr-pulse {\r\n    0%   { transform: scale(1); }\r\n    50%  { transform: scale(1.1); }\r\n    100% { transform: scale(1); }\r\n}\r\n\r\n.wxr-pulsing {\r\n    animation: wxr-pulse 2s infinite;\r\n}\r\n\r\n.wxr-chat-window {\r\n    font-family: \"DM Sans\", sans-serif;\r\n    font-weight: normal;\r\n    width: 400px;\r\n    height: 550px;\r\n    background-color: transparent;\r\n    border: none;\r\n    border-radius: 10px 10px 0 0;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    display: flex !important;\r\n    flex-direction: column;\r\n    z-index: 10000000 !important;\r\n    opacity: 1;\r\n    transition: opacity 0.5s ease, transform 0.5s ease;\r\n}\r\n\r\n.wxr-chat-header {\r\n    background-color: transparent;\r\n    color: white;\r\n    padding: 10px;\r\n    padding-right: 15px;\r\n    border-radius: 10px 10px 0 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.wxr-chat-header-title {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.wxr-chat-header-title img {\r\n    vertical-align: middle;\r\n}\r\n\r\n.wxr-logo-message-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.wxr-chat-body {\r\n    flex: 1;\r\n    padding: 10px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n    text-align: left;\r\n}\r\n\r\n.wxr-chat-body p {\r\n    margin: 5px;\r\n    width: 80%;\r\n}\r\n\r\n.wxr-chat-footer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    background-color: white;\r\n    gap: 10px;\r\n}\r\n\r\n.wxr-powered-by {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.wxr-powered-by-text {\r\n    font-size: 10px;\r\n    color: rgb(146, 146, 146);\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n.wxr-input-send-container {\r\n    display: flex;\r\n    border-top: 1px solid #ccc;\r\n    padding-top: 10px;\r\n}\r\n\r\n.wxr-chat-footer input {\r\n    flex: 1;\r\n    padding: 7px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    outline: none;\r\n    font-size: 16px;\r\n}\r\n\r\n.wxr-chat-footer button {\r\n    margin-left: 10px;\r\n    padding: 5px 10px;\r\n    padding-right: 13px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n.wxr-chat-footer button:hover {\r\n    background-color: #0595d3;\r\n}\r\n\r\n.wxr-onboarding-chat-title {\r\n    font-weight: 700;\r\n}\r\n\r\n.wxr-onboarding-widget-close-button {\r\n    font-size: 1.5rem;\r\n    line-height: 1;\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    margin: 0;\r\n    padding: 0;\r\n    outline: none;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.wxr-onboarding-widget-close-button:hover {\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.wxr-onboarding-send-message {\r\n    padding: 10px !important;\r\n    padding-left: 13px !important;\r\n    padding-right: 13px !important;\r\n    margin-left: 5px !important;\r\n}\r\n\r\n/* â”€â”€ Subscription section (plans) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-subscription-section {\r\n    text-align: center;\r\n    max-width: 1100px;\r\n    margin: 0 auto;\r\n    padding: var(--wxr-sp-4) var(--wxr-sp-3);\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    padding-left: 15px;\r\n    background: linear-gradient(to right, #ffffff, var(--wxr-c-grey-100));\r\n    border-radius: var(--wxr-r-m);\r\n}\r\n\r\n.wxr-plan-wait-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.wxr-plan-slider-wrapper {\r\n    padding-inline: var(--wxr-sp-2);\r\n    padding-top: 18px;\r\n    overflow-x: auto;\r\n    overflow-y: visible;\r\n    -webkit-overflow-scrolling: touch;\r\n    scroll-snap-type: x mandatory;\r\n}\r\n\r\n.wxr-plan-slider-wrapper::-webkit-scrollbar { height: 8px; }\r\n.wxr-plan-slider-wrapper::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }\r\n.wxr-plan-slider-wrapper::-webkit-scrollbar-thumb { background: #c4c4c4; border-radius: 4px; }\r\n.wxr-plan-slider-wrapper::-webkit-scrollbar-thumb:hover { background: #a0a0a0; }\r\n\r\n@media (max-width: 480px) {\r\n    .wxr-plan-slider-wrapper::-webkit-scrollbar { height: 0; }\r\n}\r\n\r\n.wxr-plan-slider {\r\n    display: flex;\r\n    gap: var(--wxr-sp-3);\r\n    width: max-content;\r\n}\r\n\r\n.wxr-plan-card {\r\n    flex: 0 0 280px;\r\n    min-width: 280px;\r\n    scroll-snap-align: center;\r\n    background: #ffffff;\r\n    border: 2px solid #bdb4f1;\r\n    border-radius: var(--wxr-r-m);\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: left;\r\n    padding: var(--wxr-sp-3) var(--wxr-sp-3);\r\n    transition: transform 0.3s, box-shadow 0.3s;\r\n    box-shadow: none;\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n}\r\n\r\n.wxr-plan-badge {\r\n    position: absolute;\r\n    top: -14px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background: #5616ea;\r\n    color: #ffffff;\r\n    padding: 6px 12px;\r\n    font-size: 0.90rem;\r\n    font-weight: 600;\r\n    line-height: 1;\r\n    border-radius: 16px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\r\n    white-space: nowrap;\r\n}\r\n\r\n.wxr-plan-card h3 {\r\n    margin: 0 0 var(--wxr-sp-2);\r\n    font-size: clamp(1.25rem, 1vw + 1rem, 1.7rem);\r\n    color: var(--wxr-c-primary);\r\n}\r\n\r\n.wxr-plan-features {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: 0.2rem;\r\n}\r\n\r\n.wxr-plan-features li {\r\n    font-size: 1rem;\r\n    margin-bottom: 0.8rem;\r\n    color: #333;\r\n}\r\n\r\n.wxr-plan-features svg {\r\n    margin-bottom: -0.5px;\r\n}\r\n\r\n.wxr-plan-icons-included {\r\n    margin-right: 0.5rem;\r\n    color: #5616ea;\r\n}\r\n\r\n.wxr-plan-icons-not-included {\r\n    margin-right: 0.5rem;\r\n    color: #e51616;\r\n}\r\n\r\n.wxr-feature-platform-icon {\r\n    height: 18px;\r\n    width: auto;\r\n    margin-left: 10px;\r\n    vertical-align: middle;\r\n    position: relative;\r\n    top: 0px;\r\n    object-fit: contain;\r\n}\r\n\r\n/* Feature rows that carry platform icons (Messaging / Sync data):\r\n   keep the checkmark, label and logos on one centered line, wrapping\r\n   gracefully on narrow cards instead of overflowing. */\r\n.wxr-plan-feature-icons {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    row-gap: 4px;\r\n}\r\n\r\n/* â”€â”€ Tooltips on platform icons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-icon-tooltip-wrapper {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n}\r\n\r\n.wxr-icon-tooltip-wrapper .wxr-feature-platform-icon {\r\n    margin-left: 0;\r\n    transition: transform 0.2s ease, filter 0.2s ease;\r\n}\r\n\r\n.wxr-icon-tooltip-wrapper:hover .wxr-feature-platform-icon {\r\n    transform: scale(1.15) translateY(-2px);\r\n    filter: drop-shadow(0 4px 8px rgba(86, 22, 234, 0.25));\r\n}\r\n\r\n.wxr-icon-tooltip {\r\n    position: absolute;\r\n    bottom: calc(100% + 12px);\r\n    left: 50%;\r\n    transform: translateX(-50%) translateY(8px);\r\n    padding: 10px 14px;\r\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\r\n    color: #ffffff;\r\n    font-size: 0.8rem;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n    border-radius: 10px;\r\n    box-shadow:\r\n        0 10px 40px rgba(0, 0, 0, 0.25),\r\n        0 0 0 1px rgba(255, 255, 255, 0.1),\r\n        inset 0 1px 0 rgba(255, 255, 255, 0.1);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition:\r\n        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),\r\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\r\n        visibility 0.3s;\r\n    z-index: 100;\r\n    pointer-events: none;\r\n    backdrop-filter: blur(10px);\r\n    letter-spacing: 0.3px;\r\n}\r\n\r\n.wxr-icon-tooltip::before {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -6px;\r\n    left: 50%;\r\n    transform: translateX(-50%) rotate(45deg);\r\n    width: 12px;\r\n    height: 12px;\r\n    background: linear-gradient(135deg, transparent 50%, #16213e 50%);\r\n    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);\r\n    border-radius: 0 0 3px 0;\r\n}\r\n\r\n.wxr-icon-tooltip-wrapper:hover .wxr-icon-tooltip {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    transform: translateX(-50%) translateY(0);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-facebook {\r\n    background: linear-gradient(135deg, #1877f2 0%, #0d65d9 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-facebook::before {\r\n    background: linear-gradient(135deg, transparent 50%, #0d65d9 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-instagram {\r\n    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-instagram::before {\r\n    background: linear-gradient(135deg, transparent 50%, #bc1888 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-whatsapp {\r\n    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-whatsapp::before {\r\n    background: linear-gradient(135deg, transparent 50%, #128c7e 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-google-drive {\r\n    background: linear-gradient(135deg, #4285f4 0%, #34a853 50%, #fbbc05 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-google-drive::before {\r\n    background: linear-gradient(135deg, transparent 50%, #fbbc05 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-onedrive {\r\n    background: linear-gradient(135deg, #0078d4 0%, #005a9e 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-onedrive::before {\r\n    background: linear-gradient(135deg, transparent 50%, #005a9e 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-notion {\r\n    background: linear-gradient(135deg, #2f2f2f 0%, #000000 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-notion::before {\r\n    background: linear-gradient(135deg, transparent 50%, #000000 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-telegram {\r\n    background: linear-gradient(135deg, #2aabee 0%, #229ed9 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-telegram::before {\r\n    background: linear-gradient(135deg, transparent 50%, #229ed9 50%);\r\n}\r\n\r\n.wxr-icon-tooltip.wxr-slack {\r\n    background: linear-gradient(135deg, #611f69 0%, #4a154b 100%);\r\n}\r\n.wxr-icon-tooltip.wxr-slack::before {\r\n    background: linear-gradient(135deg, transparent 50%, #4a154b 50%);\r\n}\r\n\r\n/* â”€â”€ Plan CTA button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-wix-plan-button {\r\n    width: 100%;\r\n    gap: 0.5em;\r\n    padding: 0.65em 1.5em;\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);\r\n    color: #fff;\r\n    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);\r\n    border: 1px solid rgba(255, 255, 255, 0.4);\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.wxr-wix-plan-button::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: 12px;\r\n    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);\r\n    opacity: 0;\r\n    transition: opacity 0.4s ease;\r\n    z-index: -1;\r\n    pointer-events: none;\r\n}\r\n\r\n.wxr-wix-plan-button:hover:not(:disabled)::before { opacity: 1; }\r\n\r\n.wxr-wix-plan-button:hover:not(:disabled) {\r\n    transform: translateY(-3px);\r\n    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);\r\n}\r\n\r\n.wxr-wix-plan-button:disabled {\r\n    background: #7e868e;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* â”€â”€ Pricing indicators (mobile carousel dots) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-pricing-indicators {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: var(--wxr-sp-2);\r\n    margin-top: var(--wxr-sp-4);\r\n}\r\n\r\n.wxr-indicator {\r\n    width: 40px;\r\n    height: 8px;\r\n    border: 1px solid var(--wxr-c-grey-300);\r\n    border-radius: var(--wxr-r-s);\r\n    background: transparent;\r\n    transition: background 0.3s, border-color 0.3s;\r\n}\r\n\r\n.wxr-indicator.wxr-active {\r\n    background: var(--wxr-c-primary);\r\n    border-color: var(--wxr-c-primary);\r\n}\r\n\r\n.wxr-cancel-note {\r\n    font-size: 0.85rem;\r\n    color: var(--wxr-c-grey-600);\r\n    margin-top: 15px;\r\n    padding-inline: var(--wxr-sp-2);\r\n}\r\n\r\n/* â”€â”€ Billing toggle (Monthly / Yearly) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-billing-toggle {\r\n    position: relative;\r\n    display: inline-flex;\r\n    border: 1px solid #dddddd;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #f1f1f1;\r\n    padding: 4px;\r\n    outline: none;\r\n}\r\n\r\n.wxr-billing-thumb {\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 3px;\r\n    width: calc(50% - 3px);\r\n    height: calc(100% - 6px);\r\n    background: #ffffff;\r\n    border-radius: 6px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n    transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n    pointer-events: none;\r\n    z-index: 0;\r\n}\r\n\r\n.wxr-billing-toggle[data-cycle=\"YEAR\"] .wxr-billing-thumb {\r\n    left: 50%;\r\n}\r\n\r\n.wxr-billing-toggle button {\r\n    position: relative;\r\n    z-index: 1;\r\n    flex: 1;\r\n    padding: 5px 20px;\r\n    padding-top: 6px;\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    color: #969696;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n    outline: none;\r\n    text-align: center;\r\n}\r\n\r\n.wxr-billing-toggle button.wxr-active {\r\n    color: #2f2f2f;\r\n}\r\n\r\n/* â”€â”€ Desktop layout for plans â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n@media (min-width: 920px) {\r\n    .wxr-plan-slider-wrapper {\r\n        overflow: visible;\r\n        padding: 0;\r\n        padding-top: 18px;\r\n    }\r\n\r\n    .wxr-plan-slider {\r\n        display: grid;\r\n        width: 100%;\r\n        grid-template-columns: repeat(3, 1fr);\r\n        gap: var(--wxr-sp-4);\r\n    }\r\n\r\n    .wxr-plan-card {\r\n        flex: 0 0 auto;\r\n        min-width: unset;\r\n        max-width: 100%;\r\n        scroll-snap-align: unset;\r\n    }\r\n\r\n    .wxr-pricing-indicators {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* â”€â”€ Completion / \"live\" step â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-complete-title {\r\n    border-bottom: 1px solid var(--wxr-c-grey-300);\r\n    padding-bottom: 20px;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.wxr-live-highlight {\r\n    background: var(--wxr-c-primary);\r\n    color: #ffffff;\r\n    border-radius: 1rem;\r\n    font: 600 clamp(1rem, 3vw + 0.4rem, 1.4rem) / 1 inherit;\r\n    padding: 12px;\r\n    padding-top: 3px;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.wxr-portal-button-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.wxr-after-setup-links {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.wxr-integration-complete-content {\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: center;\r\n    font-size: 1.125rem;\r\n    font-weight: 600;\r\n    align-items: center;\r\n}\r\n\r\n/* â”€â”€ Back-button header (positions BackButton's .lp-back-btn) */\r\n.wxr-header-back-button {\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.wxr-header-back-button h2 {\r\n    margin: 0;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n/* The shared <BackButton /> component renders className=\"lp-back-btn\".\r\n   Re-declare its styling here, scoped to the WixRegister header so it\r\n   continues to look right when used inside this page only. */\r\n.wxr-header-back-button .lp-back-btn,\r\n.wxr-lp-back-btn {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    transform: translateY(-50%);\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);\r\n    border: none;\r\n    outline: none;\r\n    border-radius: 50%;\r\n    font-size: 1.125rem;\r\n    font-weight: 600;\r\n    color: white;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,.12);\r\n    transition: transform .25s, box-shadow .25s;\r\n}\r\n\r\n.wxr-header-back-button .lp-back-btn:hover,\r\n.wxr-lp-back-btn:hover {\r\n    transform: translateY(-50%) translateX(-2px);\r\n    box-shadow: 0 6px 16px rgba(0,0,0,.16);\r\n}\r\n\r\n.wxr-header-back-button .lp-back-btn:active,\r\n.wxr-lp-back-btn:active {\r\n    transform: translateY(-50%) translateX(0);\r\n    box-shadow: 0 3px 8px rgba(0,0,0,.12);\r\n}\r\n\r\n/* â”€â”€ Loading container â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-loading-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    min-height: 200px;\r\n}\r\n\r\n.wxr-spinner {\r\n    margin-top: 100px;\r\n    border: 8px solid #f3f3f3;\r\n    border-top: 8px solid #5616ea;\r\n    border-radius: 50%;\r\n    width: 80px;\r\n    height: 80px;\r\n    animation: wxr-spin 1.1s linear infinite;\r\n}\r\n\r\n/* â”€â”€ Misc small bits â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-chatbot-loading-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: #5616ea;\r\n    font-weight: 600;\r\n    font-size: 1.1rem;\r\n    margin-top: 10px;\r\n}\r\n\r\n.wxr-wix-plan-price {\r\n    margin: 0;\r\n    font-size: 22px;\r\n    font-weight: 700;\r\n}\r\n\r\n.wxr-wix-plan-month {\r\n    margin: 0;\r\n    font-size: 13px;\r\n    color: grey;\r\n    margin-top: 2px;\r\n    font-style: italic;\r\n}\r\n\r\n/* â”€â”€ Yearly cross-out price block â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-yearly-crossout {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.wxr-yearly-crossout .wxr-old-price {\r\n    text-decoration: line-through;\r\n    text-decoration-thickness: 1.5px;\r\n    text-decoration-color: #5616ea;\r\n    opacity: .8;\r\n    font-size: 18px;\r\n}\r\n\r\n.wxr-yearly-crossout .wxr-deal-tag {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 7px;\r\n    padding-top: 4px;\r\n    padding-bottom: 4px;\r\n    font-size: .75rem;\r\n    font-weight: 700;\r\n    border-radius: 10px;\r\n    background: #5616ea;\r\n    color: white;\r\n    border: none;\r\n    text-align: center;\r\n    height: 80%;\r\n}\r\n\r\n/* â”€â”€ Free-plan link â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-free-plan-link { margin: 0; }\r\n\r\n.wxr-free-plan-link-button {\r\n    background: none;\r\n    border: none;\r\n    color: #5616ea;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    font-size: 0.85rem;\r\n    text-decoration: underline;\r\n    margin: 0;\r\n}\r\n\r\n.wxr-free-plan-link-button:hover { opacity: 0.8; }\r\n\r\n/* â”€â”€ Price cross-fade swap â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n.wxr-price-swap {\r\n    position: relative;\r\n    min-height: 60px;\r\n    will-change: opacity, transform;\r\n}\r\n\r\n.wxr-price-swap .wxr-pane {\r\n    position: absolute;\r\n    inset: 0;\r\n    opacity: 0;\r\n    transform: translateY(8px);\r\n    transition:\r\n        opacity var(--wxr-swap-dur-out) cubic-bezier(.22,.7,.18,1),\r\n        transform var(--wxr-swap-dur-out) cubic-bezier(.22,.7,.18,1);\r\n    pointer-events: none;\r\n}\r\n\r\n.wxr-price-swap .wxr-pane.wxr-show {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition:\r\n        opacity var(--wxr-swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--wxr-swap-delay-in),\r\n        transform var(--wxr-swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--wxr-swap-delay-in);\r\n    pointer-events: auto;\r\n}\r\n\r\n.wxr-price-swap .wxr-pane .wxr-deal-tag {\r\n    transform: scale(.94);\r\n    opacity: 0;\r\n    transition:\r\n        transform 260ms cubic-bezier(.22,.7,.18,1) calc(var(--wxr-swap-delay-in) + 80ms),\r\n        opacity   260ms cubic-bezier(.22,.7,.18,1) calc(var(--wxr-swap-delay-in) + 80ms);\r\n}\r\n\r\n.wxr-price-swap .wxr-pane.wxr-show .wxr-deal-tag {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n}\r\n\r\n.wxr-price-swap .wxr-pane .wxr-old-price {\r\n    opacity: 0;\r\n    transition: opacity 280ms ease calc(var(--wxr-swap-delay-in) + 60ms);\r\n}\r\n.wxr-price-swap .wxr-pane.wxr-show .wxr-old-price {\r\n    opacity: .9;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .wxr-price-swap .wxr-pane,\r\n    .wxr-price-swap .wxr-pane.wxr-show,\r\n    .wxr-price-swap .wxr-pane .wxr-deal-tag,\r\n    .wxr-price-swap .wxr-pane .wxr-old-price {\r\n        transition: none !important;\r\n        transform: none !important;\r\n        opacity: 1 !important;\r\n    }\r\n}\r\n\r\n/* â”€â”€ Mobile overrides â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\r\n@media (max-width: 480px) {\r\n    .wxr-preview-card {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .wxr-wrapper {\r\n        padding: var(--wxr-safe-top) var(--wxr-sp-3) var(--wxr-safe-bottom);\r\n    }\r\n\r\n    .wxr-card {\r\n        padding: var(--wxr-sp-3) var(--wxr-sp-3);\r\n    }\r\n\r\n    .wxr-chatbot-card {\r\n        padding: var(--wxr-sp-3) var(--wxr-sp-2);\r\n    }\r\n\r\n    .wxr-preview-parent-container {\r\n        padding: var(--wxr-sp-3) var(--wxr-sp-2);\r\n    }\r\n\r\n    .wxr-plan-card {\r\n        flex: 0 0 260px;\r\n        min-width: 260px;\r\n    }\r\n\r\n    .wxr-plan-card p { margin: 2px; }\r\n\r\n    .wxr-plan-card h3 {\r\n        margin: 0;\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .wxr-plan-card:hover {\r\n        transform: translateY(0);\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .wxr-cancel-note {\r\n        margin: 0;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .wxr-divider {\r\n        width: 100%;\r\n        height: 1px;\r\n        background-color: #ccc;\r\n    }\r\n\r\n    .wxr-btn {\r\n        max-width: 450px;\r\n        font-size: 1.1875rem;\r\n        padding-top: 12px;\r\n        padding-bottom: 12px;\r\n    }\r\n\r\n    .wxr-live-highlight {\r\n        padding: 0.25em 0.6em;\r\n    }\r\n\r\n    .wxr-header-back-button {\r\n        margin-bottom: 18px;\r\n    }\r\n\r\n    .wxr-card-button-wrapper,\r\n    .wxr-chatbot-card,\r\n    .wxr-preview-parent-container,\r\n    .wxr-subscription-section {\r\n        max-height: calc(100svh - var(--wxr-safe-top) - 2 * var(--wxr-sp-3));\r\n        max-height: calc(100svh - var(--wxr-safe-top) - var(--wxr-safe-bottom) - 2 * var(--wxr-sp-3));\r\n    }\r\n\r\n    .wxr-logo-register-site {\r\n        width: clamp(80px, 2vw, 50px);\r\n    }\r\n\r\n    .wxr-chat-window {\r\n        max-width: 100%;\r\n        max-height: 450px;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------\r\n   Step 4 — Notification preferences (engagement)\r\n   ------------------------------------------------------------- */\r\n.wxr-register-scope .wxr-engagement-card {\r\n    background: #fff;\r\n    border: 1px solid #e8e8ee;\r\n    border-radius: var(--wxr-r-m);\r\n    padding: var(--wxr-sp-4) var(--wxr-sp-3);\r\n    padding-top: 18px;\r\n    padding-bottom: 15px;\r\n    box-shadow: 0 6px 24px rgba(86, 22, 234, 0.06);\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-info-box {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n    background: #5616ea14;\r\n    border-left: 4px solid #5616ea;\r\n    border-radius: 10px;\r\n    padding: 12px 14px;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-info-box p {\r\n    margin: 0;\r\n    font-size: 13px;\r\n    color: #2a2a35;\r\n    line-height: 1.45;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-info-icon {\r\n    color: #5616ea;\r\n    font-size: 16px;\r\n    margin-top: 2px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* ── Matrix ─────────────────────────────────────────────── */\r\n.wxr-register-scope .wxr-notify-matrix {\r\n    background: #fafaff;\r\n    border: 1px solid #ececf5;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-row {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 2.4fr) repeat(2, minmax(80px, 1fr));\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid #ececf5;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-row:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-header {\r\n    background: #f3f1fb;\r\n    padding: 10px 12px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-row-highlight {\r\n    background: rgba(86, 22, 234, 0.05);\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-event-col {\r\n    min-width: 0;\r\n    padding-right: 6px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-channel-col {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    gap: 4px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-channel-icon {\r\n    font-size: 14px;\r\n    color: #5616ea;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-channel-icon-brand {\r\n    line-height: 0;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-channel-label-row {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    font-size: 11.5px;\r\n    color: #4a4a55;\r\n    font-weight: 600;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-channel-label {\r\n    white-space: nowrap;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-coming-soon {\r\n    background: #ffefc7;\r\n    color: #8a5c00;\r\n    font-size: 9.5px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    padding: 1px 5px;\r\n    border-radius: 6px;\r\n    letter-spacing: 0.3px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-event-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 13.5px;\r\n    font-weight: 600;\r\n    color: #1a1a1a;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-event-icon {\r\n    color: #5616ea;\r\n    font-size: 13px;\r\n    width: 16px;\r\n    text-align: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-matrix-event-desc {\r\n    font-size: 11.5px;\r\n    color: #6a6a78;\r\n    margin-top: 2px;\r\n    text-align: left;\r\n    line-height: 1.35;\r\n}\r\n\r\n/* ── More channels, set up later in the portal ─────────────\r\n   Informational strip (dashed border = not interactive here),\r\n   visually previewing Telegram & Slack as notification channels. */\r\n.wxr-register-scope .wxr-notify-portal-channels {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px 12px;\r\n    margin-top: 12px;\r\n    padding: 11px 14px;\r\n    background: #fafaff;\r\n    border: 1px dashed #d8d0f3;\r\n    border-radius: 12px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-portal-channels-label {\r\n    font-size: 12.5px;\r\n    font-weight: 600;\r\n    color: #5616ea;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-portal-chips {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-portal-chip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 5px 11px;\r\n    background: #ffffff;\r\n    border: 1px solid #ececf5;\r\n    border-radius: 999px;\r\n    font-size: 12.5px;\r\n    font-weight: 600;\r\n    color: #4a4a55;\r\n}\r\n\r\n/* ── Recipients block ──────────────────────────────────── */\r\n.wxr-register-scope .wxr-notify-recipients {\r\n    margin-top: 18px;\r\n    padding: 16px 16px 14px;\r\n    background: #fafaff;\r\n    border: 1px solid #ececf5;\r\n    border-radius: 12px;\r\n    text-align: left;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-recipients-heading {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #1a1a1a;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-spam-warning {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    background: #fff8e1;\r\n    border: 1px solid #ffe082;\r\n    border-radius: 8px;\r\n    padding: 8px 10px;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-spam-warning p {\r\n    margin: 0;\r\n    font-size: 12px;\r\n    color: #6a4f00;\r\n    line-height: 1.4;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-spam-warning-icon {\r\n    color: #c79100;\r\n    font-size: 13px;\r\n    margin-top: 2px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-emails-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    text-align: left;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-email-row {\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-add-email-btn {\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 50px;\r\n    display: block;\r\n    margin-right: auto;\r\n    text-align: left;\r\n    padding: 0;\r\n    margin-top: 10px;\r\n    color: #5616ea;\r\n    border-radius: 10px;\r\n    font-size: 26px;\r\n    cursor: pointer;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-add-email-btn:hover {\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.wxr-register-scope .wxr-notify-error {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: #fdecea;\r\n    border: 1px solid #f5c6c2;\r\n    color: #7a1c1c;\r\n    font-size: 12.5px;\r\n    border-radius: 8px;\r\n    padding: 8px 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .wxr-register-scope .wxr-engagement-card {\r\n        padding: 18px;\r\n    }\r\n    .wxr-register-scope .wxr-notify-matrix-row {\r\n        grid-template-columns: minmax(0, 2fr) repeat(2, minmax(60px, 1fr));\r\n        gap: 2px;\r\n        padding: 8px 8px;\r\n    }\r\n    .wxr-register-scope .wxr-notify-matrix-event-title {\r\n        font-size: 12.5px;\r\n    }\r\n    .wxr-register-scope .wxr-notify-matrix-event-desc {\r\n        font-size: 11px;\r\n    }\r\n    .wxr-register-scope .wxr-notify-matrix-channel-label {\r\n        font-size: 10px;\r\n    }\r\n    .wxr-register-scope .wxr-notify-matrix-channel-icon {\r\n        font-size: 13px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
